const titleWesternSign = 'h1 class="title-western"';
const endH1Sign = '</h1>';
const imgSign = '<img';
const endImgSign = 'border="0"/>';
const opendiv = '<div style="width: 100 %; border: 1px solid #CCC;text-align: center; background-color: white">';
const closediv = '</div><div style="clear: both"></div>';
const imgFloatNoneSign = '<img  style="float:none;"  ';
const bodyTagStartSign = '<body';
const bodyTagEndSign = '">';

export const applyHtmlFormatting = (htmlContent) => {
	const headerImageExists = findTitleWesterWithHeaderImage(htmlContent);

	if (headerImageExists) {
		const imgTag = getHeaderImageTag(htmlContent);

		htmlContent = htmlContent.replace(imgTag, '');
		const formattedDiv = formatHeaderImage(imgTag);
		const headerImageAddedAfterBody = applyHeaderImageAfterBody(htmlContent, formattedDiv);

		return headerImageAddedAfterBody;
	}
	return htmlContent;
};

export const findTitleWesterWithHeaderImage = (htmlContent) => {
	const titlewesternLoc = htmlContent.indexOf(titleWesternSign);

	if (titlewesternLoc === -1){
		 return false;
	}
	const titleWesternLocEndH1 = htmlContent.indexOf(endH1Sign);

	const strBetweenh1tags = htmlContent.substr(titlewesternLoc, (titleWesternLocEndH1 - titlewesternLoc));

	const imgCount = allIndexesOf(strBetweenh1tags, imgSign);

	if (titlewesternLoc > 0 && imgCount === 1){
		return true;
	}
	return false;
};

export const getHeaderImageTag = (htmlContent) => {
	const imgStartLoc = htmlContent.indexOf(imgSign);
	const imgEndLoc = htmlContent.indexOf(endImgSign, imgStartLoc);
	const strImageTag = htmlContent.substr(imgStartLoc, (imgEndLoc - imgStartLoc) + endImgSign.length);

	return strImageTag;
};

export const formatHeaderImage = (imgTag) => {
	const applyFloatImgTag = imgTag.replace(imgSign, imgFloatNoneSign);
	const fullDiv = opendiv + applyFloatImgTag + closediv;

	return fullDiv;
};

export const applyHeaderImageAfterBody = (htmlContent, formattedDiv) => {
	const bodyStartLoc = htmlContent.indexOf(bodyTagStartSign);
	const bodyEndLoc = htmlContent.indexOf(bodyTagEndSign, bodyStartLoc);
	const strBodyTag = htmlContent.substr(bodyStartLoc, (bodyEndLoc - bodyStartLoc) + 2);
	const formatedDivAdded = htmlContent.replace(strBodyTag, strBodyTag + formattedDiv);

	return formatedDivAdded;
};

export const allIndexesOf = (strInput, searchstring) => {
	let i = 0;
	let minIndex = strInput.indexOf(searchstring);

	while (minIndex !== -1) {
		i = i + 1;
		minIndex = strInput.indexOf(searchstring, minIndex + searchstring.length);
	}
	return i;
};

export const formatSingleColumnHtml = html => {
	return html.replace(/column-count\s*:\s*\d+/, '');
};

export default {
	applyHtmlFormatting: applyHtmlFormatting,
	formatSingleColumnHtml: formatSingleColumnHtml
};